import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
var OAuthCallback = function () {
    useEffect(function () {
        // /oauth/callback page logic
        window.opener.postMessage("oauth:success", window.location.origin); // Notify parent page
        window.close(); // Close the OAuth tab
    }, []);
    return (_jsx(_Fragment, {}));
};
export default OAuthCallback;
